module.exports = __webpack_public_path__ + "071d425f91a0cb4b6bbb3afbdb2c10e1.jpg";